import { INewbuildingData } from '../../types/newbuilding';

export const newbuildingDataReducer = (state: INewbuildingData) => state || null;
